var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMCnt2Sun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 89,
    viewBox: "0 0 145 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9192 11.8769C83.4167 -2.62564 59.9034 -2.62564 45.4008 11.8769C30.8983 26.3795 30.8983 49.8927 45.4008 64.3953C59.9034 78.8978 83.4167 78.8978 97.9192 64.3953C112.422 49.8927 112.422 26.3795 97.9192 11.8769Z",
    fill: "url(#paint0_linear_90_6716)",
    stroke: "#FFE27A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2199 82.0953C68.54 87.0167 61.1531 85.5172 59.2368 78.9473C56.4575 78.9473 54.3009 78.695 52.6671 78.2712C42.6347 75.6686 52.3143 66.5991 58.5525 69.777C60.3319 58.8274 74.8401 57.0482 78.6724 61.0173C87.569 43.2242 106.594 42.9505 117.27 55.1319C122.334 54.5845 124.524 55.6795 126.303 58.8274C131.864 58.3901 134.704 60.0243 136.295 62.702C137.448 64.6427 137.945 67.1315 138.348 69.777C153.541 68.6821 141.633 90.992 113.574 81.2741C105.636 91.6764 89.6221 90.5814 79.2199 82.0953Z",
    fill: "#FFFDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M79.2198 82.0953C68.5399 87.0167 61.153 85.5172 59.2367 78.9473C56.4574 78.9473 54.3008 78.695 52.667 78.2712C63.4797 74.5675 66.6278 71.5564 71.5551 75.7994C71.1445 71.4195 68.6808 69.2296 64.1641 69.777C67.0384 65.8078 75.7981 65.9447 76.2087 74.1569C82.9153 71.6932 87.9105 72.0764 92.0857 78.5368C91.544 73.1916 89.7556 71.2037 82.6416 70.3245C80.4517 57.0481 98.7923 55.4057 97.5605 66.2184C100.298 65.2603 101.391 66.2722 101.53 68.6821C104.267 63.3442 110.7 63.6179 113.301 69.0927C113.383 64.4759 111.247 60.6067 104.678 60.4699C111.111 57.185 119.733 58.8274 121.102 66.629C124.661 57.8693 133.831 60.8805 136.295 62.702C137.448 64.6427 137.945 67.1315 138.348 69.777C153.54 68.6821 141.633 90.992 113.574 81.2741C105.636 91.6764 89.622 90.5814 79.2198 82.0953Z",
    fill: "url(#paint1_linear_90_6716)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7079 56.5041C49.6418 59.6993 54.4378 58.7258 55.6819 54.4603C57.4864 54.4603 58.8866 54.2964 59.9474 54.0213C66.461 52.3315 60.1764 46.4431 56.1263 48.5064C54.971 41.3973 45.5514 40.2422 43.0633 42.8191C37.2872 31.2669 24.9351 31.0892 18.0038 38.998C14.7158 38.6426 13.294 39.3535 12.1388 41.3973C8.52817 41.1134 6.68469 42.1744 5.65172 43.913C4.90309 45.1729 4.58017 46.7888 4.3188 48.5064C-5.54509 47.7956 2.18604 62.2803 20.4031 55.971C25.5572 62.7246 35.9542 62.0137 42.7079 56.5041Z",
    fill: "#FFFDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.7078 56.5041C49.6417 59.6993 54.4377 58.7258 55.6818 54.4603C57.4864 54.4603 58.8865 54.2964 59.9473 54.0213C52.927 51.6167 50.8832 49.6617 47.6841 52.4164C47.9507 49.5728 49.5502 48.151 52.4827 48.5064C50.6166 45.9294 44.9293 46.0183 44.6627 51.3501C40.3084 49.7505 37.0653 49.9993 34.3546 54.1937C34.7062 50.7234 35.8674 49.4327 40.4861 48.8619C41.908 40.2421 30.0002 39.1758 30.8 46.196C29.0227 45.5739 28.3128 46.2309 28.223 47.7955C26.4457 44.3298 22.2691 44.5076 20.5807 48.0621C20.5272 45.0647 21.9137 42.5526 26.1791 42.4637C22.0025 40.331 16.4041 41.3973 15.5155 46.4626C13.205 40.7753 7.25117 42.7303 5.65163 43.913C4.903 45.1729 4.58008 46.7888 4.31871 48.5064C-5.54518 47.7956 2.18595 62.2803 20.403 55.971C25.5571 62.7246 35.9541 62.0137 42.7078 56.5041Z",
    fill: "url(#paint2_linear_90_6716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_6716",
    x1: 53.3006,
    y1: 5.38122,
    x2: 71.66,
    y2: 75.2722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFD8",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_6716",
    x1: 98.8335,
    y1: 57.9562,
    x2: 111.389,
    y2: 90.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_6716",
    x1: 29.9735,
    y1: 40.8317,
    x2: 21.8221,
    y2: 62.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7043"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCnt2Sun);
export default __webpack_public_path__ + "static/media/m_cnt2_sun.7736c9abf65727a524eb122a76dd2898.svg";
export { ForwardRef as ReactComponent };